// Modules
import { useAppDispatch, useAppSelector } from "app/hooks/hooks";
import { useEffect, useState } from "react";
import { resetReimbursementDetailsMonthlyDeclarations } from "redux/reimbursement/reimbursementSlice";

// Redux
import { selectedOutletCodeSelector, updateSelectedOutletCode } from "redux/userList/userSlice";

// Type Definition
import type { OutletItem } from "services/api/types";

export function useSideNavInputSearch(outlets?: Array<OutletItem>) {
	const dispatch = useAppDispatch();
	const outletCode = useAppSelector(selectedOutletCodeSelector);

	// Initial State undefined as ANT Select Component placeholder will be hidden if value is empty or null
	const [searchInput, setSearchInput] = useState<string | undefined>(undefined);
	const [selectedValue, setSelectedValue] = useState<string>("");

	useEffect(() => {
		if (outlets && !outletCode) {
			dispatch(updateSelectedOutletCode(outlets?.[0].outlet_code));
		}
	}, []);

	const onChange = (value: string) => {
		setSelectedValue(value);
		setSearchInput("");
		dispatch(resetReimbursementDetailsMonthlyDeclarations());
		dispatch(updateSelectedOutletCode(value.split("*")[1]));
	};

	const onSearch = (value: string) => {
		setSearchInput(value);
	};

	return { searchInput, selectedValue, onSearch, onChange };
}
